<template>
  <div>

    <!-- ── Cabeçalho com navegação integrada ─────────────────────────────── -->
    <v-col cols="12" class="pb-2 d-none d-md-block">
      <div class="module-header">

        <!-- Ícone + Título -->
        <div class="module-header-icon">
          <v-icon size="18" color="white">mdi-book-open-page-variant-outline</v-icon>
        </div>
        <span class="module-header-title">WoliHub</span>

        <!-- Separador vertical -->
        <div class="header-sep d-none d-md-block" />

        <!-- Pills de navegação (desktop) -->
        <div class="header-pills d-none d-md-flex">
          <button
              v-for="item in menu"
              :key="item.to"
              class="header-pill"
              :class="{ 'header-pill--active': isActive(item.to) }"
              @click="navegar(item.to)"
          >
            <v-icon
                class="header-pill-icon"
                :size="13"
                :color="isActive(item.to) ? '#023449' : 'rgba(255,255,255,0.6)'"
            >{{ item.icon }}</v-icon>
            <span class="header-pill-label">{{ item.titulo }}</span>
          </button>
        </div>

        <v-spacer />


      </div>
    </v-col>

    <!-- ── Dialog Exceções ────────────────────────────────────────────────── -->
    <DialogExcecaoClientes v-model="dialogExcecao" />

    <!-- ── Bottom navigation mobile (position: fixed — sem afetar o fluxo) ── -->
    <div v-if="menu.length > 1" class="d-flex d-md-none bottom-bar">
      <button
          v-for="item in menu"
          :key="`m-${item.to}`"
          class="bottom-item"
          :class="{ 'bottom-item--active': isActive(item.to) }"
          @click="navegar(item.to)"
      >
        <div class="bottom-indicator" />
        <v-icon
            :size="21"
            :color="isActive(item.to) ? '#023449' : '#a8bed0'"
        >{{ item.icon }}</v-icon>
        <span class="bottom-label">{{ item.titulo_app || item.titulo }}</span>
      </button>
      <!-- Exceções no mobile: ícone extra no bottom bar -->
      <button
          v-if="permissao('wolihub_cliente_excecao')"
          class="bottom-item"
          @click="dialogExcecao = true"
      >
        <div class="bottom-indicator" />
        <v-icon :size="21" color="#a8bed0">mdi-account-cancel-outline</v-icon>
        <span class="bottom-label">Exceções</span>
      </button>
    </div>

    <!-- ── Conteúdo da rota ativa ─────────────────────────────────────────── -->
    <v-col cols="12">
      <router-view />
    </v-col>

    <!-- ── Espaçador abaixo do conteúdo (evita que a bottom bar cubra o fim da página) -->
    <div v-if="menu.length > 1" class="d-block d-md-none bottom-spacer" />

  </div>
</template>

<script>
import { mapState } from 'vuex'
import DialogExcecaoClientes from './Widgets/DialogExcecaoClientes.vue'

export default {
  name: 'WolihubContainer',

  components: { DialogExcecaoClientes },

  data: () => ({
    menu:          [],
    dialogExcecao: false,
  }),

  computed: {
    ...mapState(['usuario']),
  },

  methods: {
    isActive(to) {
      return this.$route.path === to
    },

    navegar(to) {
      if (this.$route.path !== to) {
        this.$router.push(to)
      }
    },

    montarMenu() {
      const m = []

      m.push({
        titulo:     'Início',
        titulo_app: 'Início',
        icon:       'mdi-home-outline',
        to:         '/wolihub',
      })

      m.push({
        titulo:     'Vendas',
        titulo_app: 'Vendas',
        icon:       'mdi-receipt-text-outline',
        to:         '/wolihub/vendas',
      })

      //teste de atualização
      // if (this.permissao('wolihub_dashboard')) {
      if (this.permissao('wolihub_dashboard')) {
        m.push({
          titulo:     'Dashboard',
          titulo_app: 'Dashboard',
          icon:       'mdi-view-dashboard-outline',
          to:         '/wolihub/dashboard',
        })
      }

      if (this.permissao('wolihub_auditoria')) {
        m.push({
          titulo:     'Auditoria',
          titulo_app: 'Auditoria',
          icon:       'mdi-clipboard-search-outline',
          to:         '/wolihub/auditoria',
        })
      }

      this.menu = m
    },
  },

  mounted() {
    this.montarMenu()
  },
}
</script>

<style scoped>
/* ══════════════════════════════════════════════════════════════════════════
   HEADER
══════════════════════════════════════════════════════════════════════════ */
.module-header {
  display: flex;
  align-items: center;
  gap: 10px;
  background: linear-gradient(135deg, #023449 0%, #0477a1 100%);
  border-radius: 10px;
  padding: 8px 10px 8px 14px;
}

.module-header-icon {
  width: 32px;
  height: 32px;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.module-header-title {
  font-size: 14px;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: -0.1px;
  white-space: nowrap;
  flex-shrink: 0;
}

/* Separador vertical entre título e pills */
.header-sep {
  width: 1px;
  height: 18px;
  background: rgba(255, 255, 255, 0.2);
  flex-shrink: 0;
  margin: 0 2px;
}

/* ── Pills de navegação (desktop) ──────────────────────────────────────── */
.header-pills {
  display: flex;
  align-items: center;
  gap: 2px;
}

.header-pill {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  border-radius: 7px;
  border: none;
  background: transparent;
  cursor: pointer;
  outline: none;
  font-family: inherit;
  font-size: 12px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.65);
  white-space: nowrap;
  transition: background 0.18s ease, color 0.18s ease;
  user-select: none;
}

.header-pill:hover:not(.header-pill--active) {
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.92);
}

.header-pill--active {
  background: rgba(255, 255, 255, 0.95);
  color: #023449;
  font-weight: 600;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.18);
}

.header-pill-icon {
  flex-shrink: 0;
  transition: color 0.18s ease;
}

.header-pill-label {
  line-height: 1;
}

/* ══════════════════════════════════════════════════════════════════════════
   MOBILE — BOTTOM NAVIGATION
══════════════════════════════════════════════════════════════════════════ */
.bottom-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 200;
  display: flex;
  align-items: stretch;
  background: #ffffff;
  border-top: 1px solid #dde8f0;
  box-shadow: 0 -3px 16px rgba(2, 52, 73, 0.09);
  padding-bottom: env(safe-area-inset-bottom, 0px);
}

.bottom-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  padding: 8px 4px 6px;
  border: none;
  background: transparent;
  cursor: pointer;
  outline: none;
  font-family: inherit;
  position: relative;
  transition: background 0.15s ease;
}

.bottom-item:active {
  background: rgba(2, 52, 73, 0.04);
}

.bottom-indicator {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 28px;
  height: 3px;
  border-radius: 0 0 4px 4px;
  background: transparent;
  transition: background 0.18s ease;
}
.bottom-item--active .bottom-indicator {
  background: #023449;
}

.bottom-label {
  font-size: 10px;
  font-weight: 500;
  color: #a8bed0;
  line-height: 1;
  transition: color 0.18s ease, font-weight 0.1s;
}
.bottom-item--active .bottom-label {
  color: #023449;
  font-weight: 700;
}

.bottom-spacer {
  width: 100%;
  height: calc(64px + env(safe-area-inset-bottom, 0px));
}
</style>
